// extracted by mini-css-extract-plugin
module.exports = {"Accordions":"styles_Accordions__t3Znv","height":"styles_height__3cfQ8"};